<header class="dialog-header">
  <h3 class="header-heading">
    <span class="card-type" [ngClass]="form.get('cardType').value">
      <i [ngClass]="cardIcon"></i>
      {{ cardLabel }}
    </span>
    <span class="heading-text" *ngIf="data.action === CardAction.SUBSCRIBE">{{ 'pages.user-cards.create.heading' | translate }}</span>
    <span class="heading-text" *ngIf="data.action === CardAction.RENEW">{{ 'pages.user-cards.renew.heading' | translate }}</span>
  </h3>
  <button 
    class="close-button" 
    (click)="closeDialog()"
  ></button>
</header>

<!-- Search loading -->
<div *ngIf="searchLoading" class="dialog-content">
  <div class="search-loading">
    <mat-spinner diameter="40"></mat-spinner>
    <p>{{ 'pages.user-cards.search.verifying' | translate }}</p>
  </div>
</div>

<!-- Search results -->
<div *ngIf="searchResult && !searchLoading" class="dialog-content">

  <!-- FOUND -->
  <div *ngIf="searchResult.status === 'FOUND'" class="search-result-status">
    <div class="search-result-icon neutral">
      <mat-icon>menu_book</mat-icon>
    </div>
    <h3>{{ 'pages.user-cards.search.create.found.title' | translate }}</h3>
    <p *ngIf="searchResult.card?.number || searchResult.card?.code" class="card-number">{{ 'pages.user-cards.search.cardNumber' | translate }} {{ searchResult.card?.code || searchResult.card?.number }}</p>
    <button class="bciti-button bciti-button--blue" (click)="addFoundCard()">
      {{ 'pages.user-cards.search.create.found.addCard' | translate }}
    </button>
  </div>

  <!-- ALREADY_LINKED -->
  <div *ngIf="searchResult.status === 'ALREADY_LINKED'" class="search-result-status">
    <div class="search-result-icon error">
      <mat-icon>warning</mat-icon>
    </div>
    <h3>{{ 'pages.user-cards.search.alreadyLinked.title' | translate }}</h3>
    <p>{{ 'pages.user-cards.search.alreadyLinked.message' | translate:{ email: searchResult.linkedToEmail } }}</p>
    <p *ngIf="searchResult.card?.number || searchResult.card?.code" class="card-number">{{ 'pages.user-cards.search.cardNumber' | translate }} {{ searchResult.card?.code || searchResult.card?.number }}</p>
    <button class="bciti-button bciti-button--blue" (click)="closeDialog()">
      {{ 'pages.user-cards.common.button.close' | translate }}
    </button>
  </div>

</div>

<ng-container *ngIf="!searchResult && !searchLoading && !verificationStep">
<div class="progress" *ngIf="steps.length > 0">
  <div
    *ngFor="let step of steps; let i = index"
    class="step-progress"
    [class.active]="stepIndex === i"
  >
    <div class="chip">{{ i + 1 }}</div>
    <h4 class="step-text">{{ step }}</h4>
  </div>
</div>

<div class="dialog-content">

  <div class="step" *ngIf="stepIndex === 0">
    <step-info
      [form]="form"
      [subTypes]="subTypes"
      [instructionsStepsInfo]="instructionsStepsInfo"
      [userAddresses]="userAddresses"
      [userAddressesLoaded]="userAddressesLoaded"
      [selectedAddressIndex]="selectedAddressIndex"
      [subTypeLocked]="subTypeLocked"
      (addressSelected)="onAddressSelected($event)"
      (addNewAddress)="onAddNewAddress()"
    ></step-info>
  </div>

  <div class="step" *ngIf="stepIndex === 1">
    <step-confirmation [form]="form" [instructionsStepsConfirmation]="instructionsStepsConfirmation"></step-confirmation>

    <div class="cascade-notice" *ngIf="data.action === CardAction.RENEW && cascadeCards.length > 0">
      <p class="cascade-notice__heading">{{ 'pages.user-cards.renew.cascade.heading' | translate }}</p>
      <ul class="cascade-notice__list">
        <li
          *ngFor="let cascadeCard of cascadeCards"
          class="cascade-notice__item"
          [class.cascade-notice__item--already-renewing]="cascadeCard.alreadyRenewing"
        >
          <span class="cascade-notice__label">{{ cascadeCard.label }}</span>
          <span class="cascade-notice__already-renewing-note" *ngIf="cascadeCard.alreadyRenewing">
            {{ 'pages.user-cards.renew.cascade.alreadyRenewing' | translate }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</div>

<footer class="dialog-footer">
  <button
    *ngIf="stepIndex > 0"
    (click)="back()"
    class="bciti-inline-button back-button"
  >
    {{ 'pages.user-cards.common.button.back' | translate }}
  </button>
  <div class="spacer"></div>
  <button *ngIf="stepIndex === 0"
    [disabled]="!validateInfoStep()"
    (click)="next()"
    class="bciti-button bciti-button--blue">
    {{ 'pages.user-cards.common.button.next' | translate }}
  </button>
  <button *ngIf="stepIndex === 1"
    [disabled]="!validateCardForm() || processingSubmit"
    (click)="submit()"
    class="bciti-button bciti-button--blue">
    <span *ngIf="!processingSubmit">{{ 'pages.user-cards.common.button.submit' | translate }}</span>
    <mat-spinner *ngIf="processingSubmit" diameter="20"></mat-spinner>
  </button>
</footer>
</ng-container>

<!-- Verification step -->
<ng-container *ngIf="verificationStep && !searchResult && !searchLoading">
<div class="dialog-content">

  <!-- Verification loading -->
  <div *ngIf="verificationLoading" class="verification-loading">
    <mat-spinner diameter="24"></mat-spinner>
    <span>{{ 'pages.userRecords.card.verification.loading' | translate }}</span>
  </div>

  <!-- Verification results -->
  <div *ngIf="verification && !verificationLoading" class="verification-section">
    <h4 class="verification-title">{{ 'pages.userRecords.card.verification.title' | translate }}</h4>

    <!-- EXACT_MATCH -->
    <div *ngIf="verification.verificationType === 'EXACT_MATCH'" class="verification-card verification-card--success">
      <div class="verification-card__header">
        <mat-icon class="verification-card__icon">check_circle</mat-icon>
        <div>
          <h4 class="verification-card__title">{{ 'pages.userRecords.card.verification.exactMatch' | translate:{ cardNumber: verification.matches[0]?.number } }}</h4>
        </div>
      </div>
      <div class="verification-card__badge" *ngIf="verification.matches[0]?.number">
        <mat-icon>credit_card</mat-icon>
        <span>{{ verification.matches[0]?.number }}</span>
      </div>
    </div>

    <!-- DUPLICATE_BLOCKED -->
    <div *ngIf="verification.verificationType === 'DUPLICATE_BLOCKED'" class="verification-card verification-card--error">
      <div class="verification-card__header">
        <mat-icon class="verification-card__icon">block</mat-icon>
        <div>
          <h4 class="verification-card__title">{{ 'pages.userRecords.card.verification.duplicateBlocked' | translate:{
            cardNumber: verification.matches[0]?.number,
            email: verification.linkedToEmail
          } }}</h4>
        </div>
      </div>
    </div>

    <!-- PARTIAL_MATCH -->
    <div *ngIf="verification.verificationType === 'PARTIAL_MATCH'" class="verification-card verification-card--amber">
      <div class="verification-card__header">
        <mat-icon class="verification-card__icon">warning</mat-icon>
        <div>
          <h4 class="verification-card__title">{{ 'pages.userRecords.card.verification.partialMatch.title' | translate }}</h4>
          <p class="verification-card__body">{{ 'pages.userRecords.card.verification.partialMatch.message' | translate }}</p>
        </div>
      </div>

      <div class="verification-candidates">
        <mat-radio-group [(ngModel)]="selectedExternalId">
          <div
            *ngFor="let match of verification.matches"
            class="verification-candidate"
            [class.verification-candidate--selected]="selectedExternalId === match.externalId"
            (click)="selectedExternalId = match.externalId; selectedCardNumber = match.code || match.number">
            <mat-radio-button [value]="match.externalId"></mat-radio-button>
            <div class="verification-candidate__info">
              <span class="verification-candidate__name">{{ match.firstName }} {{ match.lastName }}</span>
              <span class="verification-candidate__dot">&middot;</span>
              <span>{{ formatDate(match.birthDate) }}</span>
              <span class="verification-candidate__dot">&middot;</span>
              <span>{{ match.address?.streetName }}</span>
            </div>
            <span class="verification-candidate__card" *ngIf="match.number || match.code">{{ match.code || match.number }}</span>
          </div>

          <div
            class="verification-candidate"
            [class.verification-candidate--selected]="selectedExternalId === null"
            (click)="selectedExternalId = null; selectedCardNumber = null">
            <mat-radio-button [value]="null"></mat-radio-button>
            <span class="verification-candidate__name">{{ 'pages.userRecords.card.verification.partialMatch.createNew' | translate }}</span>
          </div>
        </mat-radio-group>
      </div>
    </div>

    <!-- CARD_EXISTS_INFO_MISMATCH -->
    <div *ngIf="verification.verificationType === 'CARD_EXISTS_INFO_MISMATCH'" class="verification-card verification-card--amber">
      <div class="verification-card__header">
        <mat-icon class="verification-card__icon">warning</mat-icon>
        <div>
          <h4 class="verification-card__title">{{ 'pages.userRecords.card.verification.cardExistsMismatch.title' | translate }}</h4>
          <p class="verification-card__body">{{ 'pages.userRecords.card.verification.cardExistsMismatch.message' | translate }}</p>
        </div>
      </div>

      <div class="verification-candidates">
        <mat-radio-group [(ngModel)]="selectedExternalId">
          <div
            *ngFor="let match of verification.matches"
            class="verification-candidate"
            [class.verification-candidate--selected]="selectedExternalId === match.externalId"
            (click)="selectedExternalId = match.externalId; selectedCardNumber = match.code || match.number">
            <mat-radio-button [value]="match.externalId"></mat-radio-button>
            <div class="verification-candidate__info">
              <span class="verification-candidate__name">{{ match.firstName }} {{ match.lastName }}</span>
              <ng-container *ngIf="match.birthDate">
                <span class="verification-candidate__dot">&middot;</span>
                <span>{{ match.birthDate | date:'mediumDate':'UTC' }}</span>
              </ng-container>
              <span class="verification-candidate__dot">&middot;</span>
              <span>{{ match.address?.streetName }}</span>
            </div>
            <span class="verification-candidate__card" *ngIf="match.number || match.code">{{ match.code || match.number }}</span>
          </div>
        </mat-radio-group>
      </div>
    </div>

    <!-- NO_MATCH -->
    <div *ngIf="verification.verificationType === 'NO_MATCH'" class="verification-card verification-card--info">
      <div class="verification-card__header">
        <mat-icon class="verification-card__icon">info</mat-icon>
        <div>
          <h4 class="verification-card__title">{{ 'pages.userRecords.card.verification.noMatch.title' | translate }}</h4>
          <p class="verification-card__body">{{ 'pages.userRecords.card.verification.noMatch.message' | translate }}</p>
        </div>
      </div>
    </div>
  </div>

</div>

<footer class="dialog-footer">
  <button
    (click)="backFromVerification()"
    class="bciti-inline-button back-button"
  >
    {{ 'pages.user-cards.common.button.back' | translate }}
  </button>
  <div class="spacer"></div>
  <button
    *ngIf="verification?.verificationType !== 'DUPLICATE_BLOCKED'"
    [disabled]="verificationLoading || processingSubmit || (verification?.verificationType === 'CARD_EXISTS_INFO_MISMATCH' && !selectedExternalId)"
    (click)="submit()"
    class="bciti-button bciti-button--blue">
    <span *ngIf="!processingSubmit">{{ 'pages.user-cards.common.button.submit' | translate }}</span>
    <mat-spinner *ngIf="processingSubmit" diameter="20"></mat-spinner>
  </button>
  <button
    *ngIf="verification?.verificationType === 'DUPLICATE_BLOCKED'"
    (click)="closeDialog()"
    class="bciti-button bciti-button--blue">
    {{ 'pages.user-cards.common.button.close' | translate }}
  </button>
</footer>
</ng-container>
